export async function cancelVerseOfDayTriggers() {}

export async function scheduleVerseOfDayNotifications(_db, _options) {}

export function scheduleVerseOfDayNotificationsDebounced(_db, _delayMs) {}

export async function triggerVerseOfDayTestNotification(_db) {}
